import(/* webpackMode: "eager" */ "/var/www/vibe/src/app/global-error.tsx");
